// Version : 0.0.2
// Author : SHIYAM
// LastEdit : SHIYAM
// Last ADD : Added version and command lines
// MODFIED DATE : 05-09-2025

const BusinessDetailsActionTypes = {
	IS_EDIT_BUSINESS_DETAILS: 'is_edit_business_details',
	BUSINESS_SUBMIT_TAB_VALUE_CHANGED: 'business_submit_tab_value_changed',
	BUSINESS_IS_OPEN_OFFCANVAS: 'business_is_open_offcanvas',

	// ADD RESPONSE
	ADD_BUSINESS_DETAILS_START: 'add_business_details_start',
	ADD_BUSINESS_DETAILS_SUCCESS: 'add_business_details_success',
	ADD_BUSINESS_DETAILS_FAILURE: 'add_business_details_failure',
	ADD_BUSINESS_DETAILS_RESPONSE_RESET: 'add_business_details_response_reset',
	ADD_BUSINESS_DETAILS_RESPONSE_CHANGED: 'add_business_details_response_changed',

	// UPDATE RESPONSE
	UPDATE_BUSINESS_DETAILS_START: 'update_business_details_start',
	UPDATE_BUSINESS_DETAILS_SUCCESS: 'update_business_details_success',
	UPDATE_BUSINESS_DETAILS_FAILURE: 'update_business_details_failure',
	UPDATE_BUSINESS_DETAILS_RESPONSE_RESET: 'update_business_details_response_reset',
	UPDATE_BUSINESS_DETAILS_RESPONSE_CHANGED: 'update_business_details_response_changed',

	// FETCH RESPONSE
	FETCH_BUSINESS_DETAILS_START: 'fetch_business_details_start',
	FETCH_BUSINESS_DETAILS_SUCCESS: 'fetch_business_details_success',
	FETCH_BUSINESS_DETAILS_FAILURE: 'fetch_business_details_failure',
	FETCH_BUSINESS_DETAILS_RESPONSE_RESET: 'fetch_business_details_response_reset',
	FETCH_BUSINESS_DETAILS_RESPONSE_CHANGED: 'fetch_business_details_response_changed',

	// DELET BUSINESS REPONSE
	DELETE_BUSINESS_DETAILS_START: 'delete_business_details_start',
	DELETE_BUSINESS_DETAILS_SUCCESS: 'delete_business_details_success',
	DELETE_BUSINESS_DETAILS_FAILURE: 'delete_business_details_failure',
	DELETE_BUSINESS_DETAILS_RESPONSE_RESET: 'delete_business_details_response_reset',
	DELETE_BUSINESS_DETAILS_RESPONSE_CHANGED: 'delete_business_details_response_changed',

	// GET ALL BUSINESS RESPONSE
	GET_ALL_BUSINESS_LIST_START: 'get_all_business_list_start',
	GET_ALL_BUSINESS_LIST_SUCCESS: 'get_all_business_list_success',
	GET_ALL_BUSINESS_LIST_FAILURE: 'get_all_business_list_failure',
	GET_ALL_BUSINESS_LIST_RESPONSE_RESET: 'get_all_business_list_response_reset',
	GET_ALL_BUSINESS_LIST_RESPONSE_CHANGED: 'get_all_business_list_response_changed',

	/********** BUSINESS DETAILS EXIST CHECK START **********/
	CHECK_BUSINESS_DETAILS_EXIST_START: 'check_business_details_exist_start',
	CHECK_BUSINESS_DETAILS_EXIST_SUCCESS: 'check_business_details_exist_success',
	CHECK_BUSINESS_DETAILS_EXIST_FAILURE: 'check_business_details_exist_failure',
	CHECK_BUSINESS_DETAILS_EXIST_RESET: 'check_business_details_exist_reset',
	CHECK_BUSINESS_DETAILS_EXIST_RESPONSE_CHANGED: 'check_business_details_exist_response_changed',
	/*********** BUSINESS DETAILS EXIST CHECK END ***********/

	/*************** START BUSINESS APPROVE DETAILS ******************/
	IS_BUSINESS_APPROVE_START: 'is_business_approve_start',
	IS_BUSINESS_APPROVE_SUCCESS: 'is_business_approve_success',
	IS_BUSINESS_APPROVE_FAILURE: 'is_business_approve_failure',
	IS_BUSINESS_APPROVE_RESET: 'is_business_approve_reset',
	IS_BUSINESS_APPROVE_RESPONSE_CHANGED: 'is_business_approve_response_changed',
	/*************** START BUSINESS APPROVE DETAILS ******************/

	IS_BUSINESS_ID_START: 'is_business_id_start',
};
export default BusinessDetailsActionTypes;
